import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRight } from 'lucide-react';
import { useContactModal } from './ContactModalContext';
export const Hero = () => {
  const {
    openModal
  } = useContactModal();
  const scrollToHowItWorks = () => {
    document.getElementById('how-it-works')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-32 pb-20 md:pt-44 md:pb-28 overflow-hidden" data-id="element-162">
      {/* Ambient background */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-sage opacity-[0.07] rounded-full blur-3xl pointer-events-none" data-id="element-163" />
      <div className="absolute top-10 right-0 w-[350px] h-[350px] bg-beige opacity-50 rounded-full blur-3xl pointer-events-none" data-id="element-164" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-beigeLight opacity-70 rounded-full blur-3xl pointer-events-none" data-id="element-165" />

      <div className="max-w-3xl lg:max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-166">
        {/* Заголовок */}
        <FadeIn data-id="element-167">
          <h1 className="font-serif text-[2.25rem] sm:text-5xl md:text-6xl leading-[1.05] text-navy mb-6 tracking-tight" data-id="element-168">
            Сказали делать операцию на позвоночнике? Проверьте,{' '}
            <span className="italic text-sage" data-id="element-169">действительно</span> ли она
            необходима.
          </h1>
        </FadeIn>

        {/* Подзаголовок */}
        <FadeIn delay={0.1} data-id="element-170">
          <p className="text-lg md:text-xl text-navyLight mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-171">
            2 экспертных мнения от ТОП-20 врачей Москвы по позвоночнику. За 48
            часов — без поездок, давления и «конвейера».
          </p>
        </FadeIn>

        {/* CTA + социальное доказательство как микрокопи под кнопкой */}
        <FadeIn delay={0.15} data-id="element-172">
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-2 justify-center items-center mb-4" data-id="element-173">
            <button onClick={() => openModal('expert')} className="bg-sage hover:bg-sageDark text-white px-8 py-4 rounded-full font-medium transition-all duration-300 shadow-soft hover:shadow-md w-full sm:w-auto" data-id="element-174">
              Заказать экспертную оценку
            </button>
            <button onClick={scrollToHowItWorks} className="group inline-flex items-center gap-1.5 text-navy hover:text-sage font-medium transition-colors px-5 py-3" data-id="element-175">
              Как это работает
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-176" />
            </button>
          </div>

          {/* Социальное доказательство — прямо под кнопкой, работает как страховка решения */}
          <div className="inline-flex items-center gap-2 text-sm text-navyLight mb-12" data-id="element-177">
            <span className="relative flex h-1.5 w-1.5" data-id="element-178">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sage opacity-75" data-id="element-179" />
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-sage" data-id="element-180" />
            </span>
            <span data-id="element-181">
              Уже помогли{' '}
              <span className="font-medium text-navy" data-id="element-182">742 пациентам</span>{' '}
              разобраться, нужна ли операция
            </span>
          </div>
        </FadeIn>

        {/* Disclaimer */}
        <FadeIn delay={0.2} data-id="element-183">
          <p className="text-xs text-navyLight/50 mt-4 max-w-md mx-auto leading-relaxed" data-id="element-184">
            Информационно-аналитическая услуга. Не заменяет очной консультации
            лечащего врача.
          </p>
        </FadeIn>
      </div>
    </section>;
};